import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { handleLogout } from "@/lib/logout";
import { BellWithDrawer } from "./app-shell-header";
import { PRODUCT_NAME } from "@shared/brand";

interface GuardianShellProps {
  children: ReactNode;
  displayName?: string;
}

/** Render the intentionally limited shell for a guardian-only account. */
export function GuardianShell({ children, displayName }: GuardianShellProps): JSX.Element {
  return <div className="min-h-dvh bg-bg-primary px-4 pb-[calc(16px+env(safe-area-inset-bottom))] pt-[calc(16px+env(safe-area-inset-top))]">
    <a
      href="#guardian-main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-bg-elevated focus:px-4 focus:py-3 focus:text-sm focus:font-medium focus:text-text-primary focus:outline-none focus:ring-2 focus:ring-interactive"
    >
      Skip to main content
    </a>
    <header className="mx-auto flex max-w-[640px] items-center justify-between gap-4 py-3">
      <div>
        <p className="text-xs font-medium text-text-secondary">{PRODUCT_NAME}</p>
        <h1 className="text-[20px] font-semibold text-text-primary">Guardian Account</h1>
        {displayName ? <p className="mt-1 text-sm text-text-secondary">{displayName}</p> : null}
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <BellWithDrawer orgId={null} scopePending={false} />
        <Button
          type="button"
          variant="ghost"
          onClick={() => { void handleLogout(); }}
          className="shrink-0 border border-border-default px-4 text-sm hover:border-interactive/40"
        >
          Sign out
        </Button>
      </div>
    </header>
    <main id="guardian-main-content" tabIndex={-1} className="mx-auto max-w-[640px] py-4 focus:outline-none">{children}</main>
  </div>;
}
